export default __webpack_public_path__ + "static/media/excel.d73b2655.svg";